module.exports = __webpack_public_path__ + "static/tlinh_feature-b12c215877f2eeeba54b621c30abf613.webp";